/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Recommendation Video Component
 *
 * @file ChannelsVideoCard.jsx
 * @author Murhsid Ahamedh
 */

import React from 'react';
import PropTypes from 'prop-types';

import { ChannelsVideoCard, ChannelsProvider } from '@study/components';
import ChannelsVideoPopupClass from './ChannelsVideoCardStyle';
// eslint-disable-next-line import/no-unresolved
import '@study/components/node_modules/@aquila/media/build/index.css';

const ChannelsVideoRecommendationCard = ({
  asset,
  env,
  user,
  channelId,
  onSeeInChannelsLinkClick
}) => {
  const videoConfig = {
    creatorNameOnly: false,
    cardHeadText: 'Intro',
    linkText: 'Watch in Study Prep',
    inlineVideoPlayer: false,
    disableRedirect: false,
    hideBookmark: false,
    hideCompleted: true,
    hideMetadata: false,
    hideTitle: false,
    hidePopoutVideo: false,
    hideTutor: true,
    hideViews: true,
    hideComments: true,
    hideVotes: true,
    hideChannelsLink: false,
    hideCardHead: false,
    hideCardTitle: false,
    hideDuration: false,
    enableHoverPreview: false,
    enableTooltipOverlay: false
  };

  const trackingGlobalData = {
    location_in_app: 'video-player'
  };

  const paywallModalProps = {
    disablePortal: true,
    disableScrollLock: true,
    BackdropProps: {
      style: {
        position: 'absolute'
      }
    }
  };

  const inlineVideoConfig = React.useMemo(() => ({
    videoAutoplay: true,
    hideTitle: false,
    hideTutor: false,
    hideMetadata: true,
    hidePaywall: false,
    hideStats: false,
    hideInfo: false,
    hideActions: false,
    hideBookMarkAction: false,
    hideCompleteAction: false,
    hideRanksAction: false
  }), []);

  return (
    <ChannelsProvider channelId={channelId} env={env} user={user}>
      <ChannelsVideoCard
        key={asset.id}
        asset={asset}
        source="eTextMiniplayer"
        trackingGlobalData={trackingGlobalData}
        config={videoConfig}
        videoCallbacks={{
          onPaywallClose: () => {},
          onPaywallSubscribe: () => {},
          onPaywallShow: () => {}
        }}
        videoClasses={{
          playerWrapper: {
            borderRadius: '20px',
            border: 'none',
            backgroundColor: 'transparent'
          }
        }}
        videoConfig={inlineVideoConfig}
        paywallModalProps={paywallModalProps}
        {
        ...ChannelsVideoPopupClass
        }
        onCardClick={onSeeInChannelsLinkClick}
        onThumbnailClick={() => {}}
        onSeeInChannelsLinkClick={(url, event) => {
          onSeeInChannelsLinkClick(url, event, true);
        }}
      />
    </ChannelsProvider>
  );
};

ChannelsVideoRecommendationCard.propTypes = {
  classes: PropTypes.object.isRequired,
  asset: PropTypes.object.isRequired,
  showChannelsRecommendedPopup: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired.isRequired,
  env: PropTypes.string.isRequired,
  user: PropTypes.object.isRequired,
  channelId: PropTypes.string.isRequired,
  channelRecommendationRedirectionABTest: PropTypes.number.isRequired,
  isChannelsBundleSubscriber: PropTypes.bool.isRequired,
  handleSeeInChannelsClickFromReccomendationPopup: PropTypes.func.isRequired,
  closeVideoPopUp: PropTypes.func.isRequired,
  onSeeInChannelsLinkClick: PropTypes.func.isRequired
};
export default ChannelsVideoRecommendationCard;
